import {
    LOGGED,
    NOT_LOGGED_IN,
    LOGIN_MODAL
} from '../actions/user'

const initialTestState = {
    userData: null,
    status: null,
    modalLogin: false
}

export default ( state = initialTestState, action ) =>  {
    switch (action.type) {
        case LOGGED: {
            return {
                userData: action.payload,
                status: 'done'
            }
        }
        case NOT_LOGGED_IN: {
            return {
                userData: null,
                status: 'done'
            }
        }
        case LOGIN_MODAL: {
            return {
                ...state,
                modalLogin: action.payload
            }
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/user.js